export const AppSubscriptionClaimType: string = "subs";
